<template>
  <div class="container patient-details" v-if="patientFormData.Teksten && patientGegevens">
    <div class="row">
      <div class="col-md-12">
        <v-heading :level="1">{{ patientFormData.Teksten.Persoonsgegevens }}</v-heading>
      </div>
    </div>
    <form method="get" ref="patientForm" @submit="validateBeforeSubmit" >
      <input v-if="patientGegevens.Id === '0' || patientGegevens.Id === null ||  patientGegevens.Id === ''" type="hidden" name="Id" value="0">
      <input v-if="patientGegevens.Id !== '0'" type="hidden" name="Id" :value="patientGegevens.Id">
      <p v-if="patientFormData.Melding">{{ patientFormData.Melding }}</p>
      <div id="step1" class="row grid-margin">
        <div class="col-md-12 patient-details__block">
          <v-header title="Wijzig hier de persoonsgegevens"></v-header>
          <div class="patient-details__block__content">
            <div class="row grid-margin">
              <div class="col">
                <v-select-group
                  :label="patientFormData.Teksten.Labels.Geslacht"
                  selectid="GeslachtId"
                  v-model="patientGegevens.GeslachtId"
                  :rule="{
                    required: true,
                    in: [1, 2, 3]
                  }"
                  @change="select($event, 'GeslachtId')"
                  :initselected="patientGegevens.GeslachtId">
                  <option value="0">{{ patientFormData.Teksten.DefaultTekstGeslacht }}</option>
                  <option v-for="(item, index) in this.patientFormData.StamData.Geslachten"
                          :key="index"
                          :data-index="index" :value="item.GeslachtId">{{ item.Naam }}</option>
                </v-select-group>
                <div class="form-group-simple__details" v-if="showErrorMessage">
                  <div class="form-group-simple__messages">
                    <div class="form-group-simple__error">
                      <span> <v-error-icon></v-error-icon> Het is verplicht om het veld geslacht in te vullen. </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="patientFormData.Teksten.Labels.Voorletters"
                  v-model="patientGegevens.Voorletters"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Voorletters"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: false
                  }"
                  :id="patientFormData.Teksten.Labels.Voornaam"
                  v-model="patientGegevens.Voornaam"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Voornaam"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col">
                <v-select-group
                :name="patientFormData.Teksten.Labels.Tussenvoegsel"
                :label="patientFormData.Teksten.Labels.Tussenvoegsel"
                :selectid="patientFormData.Teksten.Labels.Tussenvoegsel"
                @change="select($event, 'Tussenvoegsel')"
                :initselected="patientGegevens.Tussenvoegsel">
                  <option value=""></option>
                  <option v-for="(item, index) in this.patientFormData.StamData.PrePositions"
                          :key="index"
                          :data-index="index" :value="item">{{ item }}</option>
                </v-select-group>
              </div>
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="patientFormData.Teksten.Labels.Achternaam"
                  v-model="patientGegevens.Achternaam"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Achternaam"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true,
                    max: 10
                  }"
                  :id="patientFormData.Teksten.Labels.Geboortedatum"
                  :disabled="birthDate !== null"
                  v-model="birthDate"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Geboortedatum"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="patientFormData.Teksten.Labels.Polisnummer"
                  v-model="patientGegevens.Polisnummer"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Polisnummer"
                  @input="saveInput"
                  :disabled="disabledFields.Polisnummer"
                  :overwriteValue="patientGegevens.Polisnummer"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col">
                <v-select-group
                  :disabled="disabledFields.VerzekeraarId"
                  :label="patientFormData.Teksten.Labels.Verzekeraar"
                  selectid="VerzekeraarId"
                  v-model="patientGegevens.VerzekeraarId"
                  :rule="{
                    required: true
                  }"
                  @change="select($event, 'VerzekeraarId')"
                  :initselected="patientGegevens.VerzekeraarId"
                  :overwriteValue="patientGegevens.VerzekeraarId">
                  <option v-for="(item, index) in this.patientFormData.StamData.Verzekeraars"
                          :key="index"
                          :data-index="index" :value="item.PayerId">{{ item.Name }}</option>
                </v-select-group>
                <div class="form-group-simple__details" v-if="showDeptErrorMessage">
                  <div class="form-group-simple__messages">
                    <div class="form-group-simple__error">
                      <span> <v-error-icon></v-error-icon> Dit veld is verplicht. </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col" v-if="showDisabledBSN">
                <v-input-group-simple-2
                  :rules="bsnRules"
                  id="BSNnummer"
                  :disabled="disabledFields.BSNnummer"
                  v-model="patientGegevens.BSNnummer"
                  type="text"
                  :label="patientFormData.Teksten.Labels.BSNnummer"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
            </div>
            <div class="row grid-margin grid-align-center" v-if="!showDisabledBSN">
              <div class="col">
                <v-input-group-simple-2
                  v-if="!NoBSNNummer"
                  :rules="bsnRules"
                  id="BSNnummer"
                  v-model="patientGegevens.BSNnummer"
                  type="text"
                  :label="patientFormData.Teksten.Labels.BSNnummer"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
                <input v-if="!NoBSNNummer" type="hidden" id="HeeftBSNNummer" name="HeeftBSNNummer" value="true">
                <v-select-group
                  v-model="patientGegevens.RedenGeenBSN"
                  :rule="{
                    required: true,
                    in: [1, 2, 3]
                  }"
                  :label="patientFormData.Teksten.Labels.RedenGeenBSN"
                  selectid="RedenGeenBSN"
                  :initselected="patientGegevens.RedenGeenBSN"
                  @change="select($event, 'RedenGeenBSN')"
                  v-if="NoBSNNummer">
                  <option value="0">{{ patientFormData.Teksten.Labels.SelecteerEenReden }}</option>
                  <option v-for="(item, index) in this.patientFormData.StamData.GeenBSNRedenen"
                          :key="index"
                          :data-index="index"
                          :value="index + 1">{{ item }}</option>
                </v-select-group>
                <div class="form-group-simple__details" v-if="showNoBSNErrorMessage">
                  <div class="form-group-simple__messages">
                    <div class="form-group-simple__error">
                      <span> <v-error-icon></v-error-icon> Het is verplicht om een reden te kiezen. </span>
                    </div>
                  </div>
                </div>
                <input v-if="NoBSNNummer" type="hidden" id="HeeftBSNNummer" name="HeeftBSNNummer" value="false">
              </div>
              <div class="col">
                <v-checkbox-group
                  v-model="NoBSNNummer"
                  :label="patientFormData.Teksten.Labels.GeenBSN"
                  inputid="NoBSNNummer"
                  :initvalue="NoBSNNummer"
                >
                </v-checkbox-group>
              </div>
            </div>
            <input v-if="patientGegevens.WoonAdres.AdresId === '0' || patientGegevens.WoonAdres.AdresId === null ||  patientGegevens.WoonAdres.AdresId === ''" type="hidden" name="WoonAdresId" value="0">
            <input v-if="patientGegevens.WoonAdres.AdresId !== '0'" type="hidden" name="WoonAdresId" :value="patientGegevens.WoonAdres.AdresId">
            <div class="row grid-margin">
              <div class="col-md-4">
                <v-input-group-simple-2
                  :rules="postCodeRule"
                  :id="'WoonAdres' + patientFormData.Teksten.Labels.Postcode"
                  :data-vv-as="patientFormData.Teksten.Labels.Postcode"
                  v-model="patientGegevens.WoonAdres.Postcode"
                  type="text"
                  @blur="autoFillAddress('WoonAdres')"
                  :label="patientFormData.Teksten.Labels.Postcode"
                  @input="saveAddressInput($event, 'WoonAdres', patientFormData.Teksten.Labels.Postcode)"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col-md-4">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="'WoonAdres' + patientFormData.Teksten.Labels.Huisnr"
                  :data-vv-as="patientFormData.Teksten.Labels.Huisnr"
                  v-model="patientGegevens.WoonAdres.Huisnummer"
                  type="text"
                  @blur="autoFillAddress('WoonAdres')"
                  :label="patientFormData.Teksten.Labels.Huisnr"
                  @input="saveAddressInput($event, 'WoonAdres', patientFormData.Teksten.Labels.Huisnr)"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col-md-4">
                <v-input-group-simple-2
                  :rules="{
                    required: false
                  }"
                  :id="'WoonAdres' + patientFormData.Teksten.Labels.Toevoeging"
                  v-model="patientGegevens.WoonAdres.Toevoeging"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Toevoeging"
                  @input="saveAddressInput($event, 'WoonAdres', patientFormData.Teksten.Labels.Toevoeging)"
                >
                </v-input-group-simple-2>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="'WoonAdres' + patientFormData.Teksten.Labels.Straatnaam"
                  :data-vv-as="patientFormData.Teksten.Labels.Straatnaam"
                  v-model="patientGegevens.WoonAdres.Straatnaam"
                  type="text"
                  :disabled="disableAddress"
                  :label="patientFormData.Teksten.Labels.Straatnaam"
                  @input="saveAddressInput($event, 'WoonAdres', patientFormData.Teksten.Labels.Straatnaam)"
                  :overwriteValue="patientGegevens.WoonAdres.Straatnaam"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col">
                <v-input-group-simple-2
                  :rules="{
                    required: true
                  }"
                  :id="'WoonAdres' + patientFormData.Teksten.Labels.Woonplaats"
                  :data-vv-as="patientFormData.Teksten.Labels.Woonplaats"
                  v-model="patientGegevens.WoonAdres.Woonplaats"
                  type="text"
                  :disabled="disableAddress"
                  :label="patientFormData.Teksten.Labels.Woonplaats"
                  @input="saveAddressInput($event, 'WoonAdres', patientFormData.Teksten.Labels.Woonplaats)"
                  :overwriteValue="patientGegevens.WoonAdres.Woonplaats"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col">
                <v-select-group
                  :label="patientFormData.Teksten.Labels.Land"
                  selectid="WoonAdresLand"
                  :initselected="patientGegevens.WoonAdres.Land || 'NL'"
                  v-model="patientGegevens.WoonAdres.Land"
                  :rule="{
                    required: true
                  }"
                  @input="onCountryChange(...arguments, 'postCodeRule')"
                  @change="autoFillAddress('WoonAdres')">
                  <option v-for="(item, index) in this.patientFormData.StamData.Landen"
                          :key="index"
                          :data-index="index" :value="item.IsoCode">{{ item.Naam }}</option>
                </v-select-group>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col">
                <v-checkbox-group
                  v-model="differentShippingAddress"
                  label="Afwijkend afleveradres opgeven"
                  inputid="addressToggle"
                  :initvalue="differentShippingAddress"
                  :overwriteValue="differentShippingAddress">
                </v-checkbox-group>
              </div>
            </div>
            <div v-if="differentShippingAddress">
              <v-heading :level="3">{{patientFormData.Teksten.AfwijkendAfleveradres}}</v-heading>
              <input v-if="patientGegevens.AfwijkendeAdres.AdresId === '0' || patientGegevens.AfwijkendeAdres.AdresId === null ||  patientGegevens.AfwijkendeAdres.AdresId === ''" type="hidden" name="AfwijkendeAdresId" value="0">
              <input v-if="patientGegevens.AfwijkendeAdres.AdresId !== null" type="hidden" name="AfwijkendeAdresId" :value="patientGegevens.AfwijkendeAdres.AdresId">
              <div class="row grid-margin">
                <div class="col-md-4">
                  <v-input-group-simple-2
                    :rules="altPostCodeRule"
                    :id="'AfwijkendeAdres' + patientFormData.Teksten.Labels.Postcode"
                    :data-vv-as="patientFormData.Teksten.Labels.Postcode"
                    v-model="patientGegevens.AfwijkendeAdres.Postcode"
                    type="text"
                    @blur="autoFillAddress('AfwijkendeAdres')"
                    :label="patientFormData.Teksten.Labels.Postcode"
                    @input="saveAddressInput($event, 'AfwijkendeAdres', patientFormData.Teksten.Labels.Postcode)"
                  >
                  </v-input-group-simple-2>
                </div>
                <div class="col-md-4">
                  <v-input-group-simple-2
                    :rules="{
                      required: true
                    }"
                    :id="'AfwijkendeAdres' + patientFormData.Teksten.Labels.Huisnr"
                    :data-vv-as="patientFormData.Teksten.Labels.Huisnr"
                    v-model="patientGegevens.AfwijkendeAdres.Huisnummer"
                    type="text"
                    @blur="autoFillAddress('AfwijkendeAdres')"
                    :label="patientFormData.Teksten.Labels.Huisnr"
                    @input="saveAddressInput($event, 'AfwijkendeAdres', patientFormData.Teksten.Labels.Huisnr)"
                  >
                  </v-input-group-simple-2>
                </div>
                <div class="col-md-4">
                  <v-input-group-simple-2
                    :rules="{
                      required: false
                    }"
                    :id="'AfwijkendeAdres' + patientFormData.Teksten.Labels.Toevoeging"
                    v-model="patientGegevens.AfwijkendeAdres.Toevoeging"
                    type="text"
                    :label="patientFormData.Teksten.Labels.Toevoeging"
                    @input="saveAddressInput($event, 'AfwijkendeAdres', patientFormData.Teksten.Labels.Toevoeging)"
                  >
                  </v-input-group-simple-2>
                </div>
              </div>
              <div class="row grid-margin">
                <div class="col">
                  <v-input-group-simple-2
                    :rules="{
                      required: true
                    }"
                    :id="'AfwijkendeAdres' + patientFormData.Teksten.Labels.Straatnaam"
                    :data-vv-as="patientFormData.Teksten.Labels.Straatnaam"
                    v-model="patientGegevens.AfwijkendeAdres.Straatnaam"
                    :disabled="disableAlternateAddress"
                    type="text"
                    :label="patientFormData.Teksten.Labels.Straatnaam"
                    @input="saveAddressInput($event, 'AfwijkendeAdres', patientFormData.Teksten.Labels.Straatnaam)"
                    :overwriteValue="patientGegevens.AfwijkendeAdres.Straatnaam"
                  >
                  </v-input-group-simple-2>
                </div>
                <div class="col">
                  <v-input-group-simple-2
                    :rules="{
                      required: true
                    }"
                    :id="'AfwijkendeAdres' + patientFormData.Teksten.Labels.Woonplaats"
                    :data-vv-as="patientFormData.Teksten.Labels.Woonplaats"
                    v-model="patientGegevens.AfwijkendeAdres.Woonplaats"
                    type="text"
                    :disabled="disableAlternateAddress"
                    :label="patientFormData.Teksten.Labels.Woonplaats"
                    @input="saveAddressInput($event, 'AfwijkendeAdres', patientFormData.Teksten.Labels.Woonplaats)"
                    :overwriteValue="patientGegevens.AfwijkendeAdres.Woonplaats"
                  >
                  </v-input-group-simple-2>
                </div>
                <div class="col">
                  <v-select-group
                    v-model="patientGegevens.AfwijkendeAdres.Land"
                    :label="patientFormData.Teksten.Labels.Land"
                    selectid="AfwijkendeAdresLand"
                    @input="onCountryChange(...arguments, 'altPostCodeRule')"
                    @change="autoFillAddress('AfwijkendeAdres')"
                    :initselected="patientGegevens.AfwijkendeAdres.Land || 'NL'">
                    <option v-for="(item, index) in this.patientFormData.StamData.Landen"
                            :key="index"
                            :data-index="index" :value="item.IsoCode">{{ item.Naam }}</option>
                  </v-select-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-heading :level="1">{{ patientFormData.Teksten.Contactgegevens }}</v-heading>
        </div>
      </div>
      <div id="step2" class="row grid-margin">
        <div class="col-md-12 patient-details__block">
          <v-header title="Wijzig hier de contactgegevens"></v-header>
          <div class="patient-details__block__content">
            <div class="row grid-margin" v-for="(customerPhoneNumber, index) in patientGegevens.CustomerPhoneNumbers"  :key="index">
              <div class="col-md-2">
                <label :for="'telephoneNumberType' + index">Type *</label>
              </div>
              <div class="col-md-10">
                <label :for="'telephoneNumber' + index">{{ patientFormData.Teksten.Labels.Telefoonnummer  + ' *' }}</label>
              </div>
              <div class="col-md-12">
                <div class="row grid-margin">
                  <div class="col-md-2 no-vertical-space">
                    <v-select-group
                      v-model="customerPhoneNumber.IsMobileNumber"
                      @input="onContactTypeChange(...arguments, index)"
                      :selectid="'telephoneNumber' + index"
                      :initselected="customerPhoneNumber.IsMobileNumber">
                      <option v-for="(item, index) in contactTypes"
                              :key="index"
                              :data-index="index" :value="item.value">{{ item.text }}</option>
                    </v-select-group>
                  </div>
                  <div class="col-md-1 no-vertical-space">
                    <vue-country-code
                      :enabledCountryCode="true"
                      :defaultCountry="customerPhoneNumber.PhoneNumberCountryCode || 'NL'"
                      :ref="'TelefoonnummerLandCode' + index"
                      @onSelect="onTelephoneNumberSelect($event, index)">
                    </vue-country-code>
                  </div>
                  <div class="col-md-4 no-vertical-space">
                    <v-input-group-simple-2
                      :rules="{
                        required: true,
                        regex: /^(?:\d{1,11}|(?=\d+ \d+$)[\d ]{3,12})$/,
                        numeric: true,
                        regex: /^(?:\d{1,11}|(?=\d+ \d+$)[\d ]{3,12})$/,
                        length: 9                        
                      }"
                      :id="patientFormData.Teksten.Labels.Telefoonnummer"
                      :value="getComputedPhoneNumber(customerPhoneNumber.PhoneNumber, index)"
                      type="text"
                      placeholder="612345678"
                      @input="savePhoneNumberInput($event, 'CustomerPhoneNumbers', index)"
                    >
                    </v-input-group-simple-2>
                  </div>
                  <div class="col-md-1 no-vertical-space grid-align-start" v-if="otherTelephoneNumber && index > 0">
                    <v-button md hollow transparent @click.native.prevent="showOtherTelephoneNumber(false, customerPhoneNumber.PhoneNumberId)">
                      <v-delete-circle-icon v-tooltip="{content: 'Verwijderen', placement: 'right', html: false}" class="step3_icon" />
                    </v-button>
                  </div>
                  <div v-if="!otherTelephoneNumber">
                    <v-button lg primary iconLeft class="phoneNumberAlign" @click.native.prevent="showOtherTelephoneNumber(true, customerPhoneNumber.PhoneNumberId)">
                      <plus-circle-icon class="step3_icon" />
                      Telefoonnummer toevoegen
                    </v-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col-md-4">
                <v-input-group-simple-2
                  :rules="{
                    required: !noEmailAddress,
                    email: true
                  }"
                  :id="patientFormData.Teksten.Labels.Emailadres"
                  v-model="patientGegevens.Emailadres"
                  type="text"
                  :label="patientFormData.Teksten.Labels.Emailadres"
                  placeholder="voorbeeld@email.com"
                  @input="saveInput"
                >
                </v-input-group-simple-2>
              </div>
              <div class="col-md-12 grid-justify-content-center" v-if="patientGegevens.Emailadres === null || patientGegevens.Emailadres === ''">
                <v-checkbox-group
                  v-model="noEmailAddress"
                  :label="patientFormData.Teksten.Labels.NoEmailAddressCheckbox"
                  inputid="chkNoEmail"
                  :initvalue="noEmailAddress"
                >
                </v-checkbox-group>
              </div>
            </div>
            <div class="row grid-margin" v-show="noEmailAddress && ( patientGegevens.Emailadres === null || patientGegevens.Emailadres === '' ) ">
              <div class="col-md-8">
                <v-warning-message :warning="patientFormData.Teksten.NoEmailAddressWarning" :html="true" :isUrgent='false' v-if="noEmailAddress"></v-warning-message>
              </div>
            </div>
          </div>
        </div>
      </div>      
      <div class="row">
        <div class="col-md-12">
          <v-heading :level="1">{{ patientFormData.Teksten.CustomerNumberTitle }}</v-heading>
        </div>
      </div>
      <div id="step3" class="row grid-margin">
        <div class="col-md-12 patient-details__block">
          <v-header :title="patientFormData.Teksten.CustomerNumberDescription"></v-header>
          <div class="patient-details__block__content">
            <div class="row grid-margin">
              <div class="col-md-4">
                <v-input-group-simple-2
                  :rules="{
                    required: false,
                    numeric: true
                  }"
                  :id="patientFormData.Teksten.CustomerNumberTitle"
                  :value="customerNumber"
                  type="text"
                  :label="patientFormData.Teksten.CustomerNumberTitle"
                  @input="saveCustomerNumber"
                >
                </v-input-group-simple-2>
              </div>
            </div>
          </div>
        </div>
      </div>        
      <div class="row">
        <div class="col-md-12">
          <v-heading :level="1">{{ patientFormData.Teksten.GegevensTitle }}</v-heading>
        </div>
      </div>
      <div id="step4" class="row grid-margin">
        <div class="col-md-12 patient-details__block">
          <v-header title="Wijzig hier de toestemming voor het delen van gegevens"></v-header>
          <div class="patient-details__block__content">
            <div class="row grid-margin">
              <div class="col GegevensDelenText">
                {{ patientFormData.Teksten.GegevensInfo }}
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col">
                <a href="" @click.prevent="openGegevensLink(patientFormData.Teksten.GegevensLinkUrl)" target="_blank" v-if="patientFormData.Teksten.GegevensLinkText" class="btn btn--link"><chevron-right class="icon-color-teal"/>{{ patientFormData.Teksten.GegevensLinkText }}</a>
              </div>
            </div>
            <div class="row grid-margin">
              <div class="col GegevensDelenText">
                {{ patientFormData.Teksten.GegevensFirstQuestion }}
              </div>
            </div>
            <div class="row grid-margin form-group__radio">
              <div class="col-md-2">
                <input id="Q1Y" name="Question1Selection" v-model="patientGegevens.HasAgreedToShareData" @change="checkRadioAnswer" type="radio" :value="true"/>
                <label for="Q1Y"><span><span></span></span>Ja</label>
              </div>
              <div class="col-md-2">
                <input id="Q1N" name="Question1Selection" v-model="patientGegevens.HasAgreedToShareData" @change="checkRadioAnswer" type="radio" :value="false"/>
                <label for="Q1N"><span><span></span></span>Nee</label>
              </div>
            </div>
            <div class="row grid-margin" v-if="!patientGegevens.HasAgreedToShareData">
              <div class="col">
                <v-warning-message :warning="patientFormData.Teksten.GegevensWarningMessageQ1" :html="true" :isUrgent='false'></v-warning-message>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="computedShowCareProgramme">
        <div class="col-md-12">
          <v-heading :level="1">Zorgprogramma</v-heading>
        </div>
      </div>
      <div id="step5" class="row grid-margin" v-if="computedShowCareProgramme">
        <div class="col-md-12 patient-details__block">
          <v-header title="Wijzig hier de toestemming voor het delen van gegevens"></v-header>
          <div class="patient-details__block__content">
            <div class="row grid-margin">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    {{patientFormData.Teksten.RegisterText}}. {{patientFormData.Teksten.CheckToAgreeText}}
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <v-table v-for="(careProgram, careProgramKey) in careProgramDetails" :key="careProgramKey">
                  <v-care-programme-row :data="careProgram" :index="careProgramKey" @careProgramAction="careProgramAction" detailsPage></v-care-programme-row>
                </v-table>
              </div>
            </div>
          </div>
        </div>        
      </div>        
      <div class="row" id="step6">
        <v-button lg hollow transparent @click.native.prevent="goBack">Annuleren</v-button>
        <v-button lg cta id="patientDetailsSave" tagelement="button">Opslaan</v-button>
      </div>
    </form>
    <generic-modal :hasCloseButton="true" v-if="newPatientIsSaved" @close="closeModal">
      <template #header>
        {{ patientDetailsSuccessPopUpDetails.Title }}
      </template>
      <template #body>
        <p>{{ patientDetailsSuccessPopUpDetails.Message }}</p>
      </template>
      <template #footer>
        <router-link :to="patientDetailsSuccessPopUpDetails.LinkButtonUrl" class="btn btn--hollow btn--transparent btn--md">{{ patientDetailsSuccessPopUpDetails.LinkButtonText }}</router-link>
        <router-link v-if="patientDetailsSuccessPopUpDetails.PrimaryButtonUrl" :to="patientDetailsSuccessPopUpDetails.PrimaryButtonUrl" class="btn btn--primary btn--md">{{ patientDetailsSuccessPopUpDetails.PrimaryButtonText }}</router-link>
        <v-button md primary v-else @click.native.prevent="closeAndScrollTop">{{ patientDetailsSuccessPopUpDetails.PrimaryButtonText }}</v-button>
      </template>
    </generic-modal>
    <generic-modal :hasCloseButton="true" v-if="covSanityCheckNotMatchedModel" @close="closeModal">
      <template #header>
        {{ covSanityCheckNotMatchedModel.Title }}
      </template>
      <template #body>
        <p>{{ covSanityCheckNotMatchedModel.Message }}</p>
      </template>
      <template #footer>
          <!-- Close dialog, save regardless of cov sanity check //-->
          <v-button v-if="covSanityCheckNotMatchedModel.CovSanityCheckStatus === 'NotMatched'" md hollow transparent @click.native.prevent="submitFormRegardlessOfCovSanityCheck">{{ covSanityCheckNotMatchedModel.LinkButtonText }}</v-button>
          <!-- Close dialog, scroll to top //-->
          <v-button v-if="covSanityCheckNotMatchedModel.CovSanityCheckStatus === 'NotMatched'" md primary @click.native.prevent="closeCovNotMatchedAndScrollTop">{{ covSanityCheckNotMatchedModel.PrimaryButtonText }}</v-button>
        <!-- scenario 3 -->
          <!-- Close dialog, save regardless of cov sanity check //-->
          <v-button v-if="covSanityCheckNotMatchedModel.CovSanityCheckStatus === 'NotMatchedPolicynumberOrHealthcareInsuranceCompany'" md hollow transparent @click.native.prevent="submitFormRegardlessOfCovSanityCheck">{{ covSanityCheckNotMatchedModel.LinkButtonText }}</v-button>
          <!-- Close dialog, overwrite what we have, submit //-->
          <v-button v-if="covSanityCheckNotMatchedModel.CovSanityCheckStatus === 'NotMatchedPolicynumberOrHealthcareInsuranceCompany'" md primary @click.native.prevent="closeCovNotMatchedAndScrollTop">{{ covSanityCheckNotMatchedModel.PrimaryButtonText }}</v-button>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import router from '@/router'
import { mapGetters, mapActions } from 'vuex'
import store from '@/store'
import plusCircleIcon from 'icons/PlusCircle'
import chevronRight from 'icons/ChevronRight'
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
import moment from 'moment'
import VTable from '@/components/shared/table/Table'
import VCareProgrammeRow from './CareProgrammeRow'
import bsnValidationRules from '@/components/shared/validationRules/bsnValidationRules.js'
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import VWarningMessage from '@/components/shared/WarningMessage'
import VDeleteCircleIcon from 'icons/DeleteCircle'
import GenericModal from '@/components/shared/GenericModal'
import { pushActiveCustomerId } from '@/services';
import VHeader from '@/components/shared/Header.vue'
import VueCountryCode from "vue-country-code"
import axios from 'axios'
import VErrorIcon from 'icons/AlertCircle';

export default {
  name: 'PatientDetails',
  components: {
    VHeader,
    plusCircleIcon,
    VCheckboxGroup,
    chevronRight,
    VTable,
    VCareProgrammeRow,
    VWarningMessage,
    VDeleteCircleIcon,
    GenericModal,
    VueCountryCode,
    VErrorIcon
  },
  computed: {
    ...mapGetters({
      currentPatientId: 'patient/getCurrentPatientId',
      patientFormData: 'patient/getAllPatientFormData',
      patientGegevens: 'patient/getPatientGegevens',
      newPatientIsSaved: 'patient/getNewPatientIsSaved',
      careProgramDetails: 'patient/getCareProgramDetails',
      formPurpose: 'patient/getFormPurpose',
      siteCode: 'navigation/getSiteCode',
      customerNumber: 'patient/getCustomerNumber'
    }),
    birthDate () {
      return this.patientGegevens.GeboorteDatum !== '0001-01-01T00:00:00' ? moment(this.patientGegevens.GeboorteDatum).format('DD-MM-YYYY') : null
    },
    computedShowCareProgramme () {
      let status = false
      Object.keys(this.careProgramDetails).forEach((key) => {
        if (this.patientGegevens.HasAgreedToShareData && this.careProgramDetails[key] !== null) {
          status = true
        }
      })
      return status
    }
  },
  data () {
    return {
      showNoBSNErrorMessage: false,
      showErrorMessage: false,
      showDeptErrorMessage: false,
      differentShippingAddress: false,
      NoBSNNummer: false,
      disabledFields: {
        BSNnummer: false,
        Polisnummer: false,
        VerzekeraarId: false
      },
      showDisabledBSN: true,
      patientDetailsSuccessPopUpDetails: {},
      covSanityCheckNotMatchedModel: null,
      intro: introJs(),
      otherTelephoneNumber: false,
      selectedCountry: '',
      postCodeRule: {
        required: true,
        max: 7,
        regex: [/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i]
      },
      altPostCodeRule: {
        required: true,
        max: 7,
        regex: [/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i]
      },
      bsnRules: bsnValidationRules,
      disableAddress: false,
      disableAlternateAddress: false,
      noEmailAddress: false,
      formSubmitted: false,
      contactTypes: [
        {value: false, text: 'Telefoon'},
        {value: true, text: 'Mobiel'}
      ]
    }
  },
  destroyed () {
    store.commit('patient/setNewPatientIsSaved', false)
    store.commit('patient/setCareProgramDetails', {})
    store.commit('patient/setPatientGegevens', {})
    store.commit('patient/setAllPatientFormData', {})
  },
  created () {
    store.commit('patient/setNewPatientIsSaved', false)
    this.fetchAllPatientFormData().then(() => {
      if (store.state.navigation.demo && store.state.navigation.demoActivated) {
        setTimeout(() => {
          this.intro.setOptions({
            steps: [
              {element: '#step1', intro: 'Aha, de patiënt was nog niet bij ons bekend: Dit betekent dat we handmatig de patiëntgegevens moeten invullen. Op deze pagina kunt u alle relevante informatie invullen om de patiënt aan te maken, te beginnen bij de persoonsgegevens. Let op! De velden met een sterretje zijn verplicht!', position: 'right'},
              {element: '#step2', intro: 'In de volgende sectie kunt u de adresgegevens van de patiënt invullen. Wanneer u de postcode en het huisnummer hebt ingevuld, worden de straatnaam en woonplaats automatisch aangevuld! Tevens is het mogelijk een afwijkend afleveradres in te vullen, mocht dit nodig zijn voor deze specifieke patiënt.', position: 'right'},
              {element: '#step3', intro: 'Onder het kopje ‘Contactgegevens’ kunt u aangeven op welke manier de patiënt te bereiken is. Het is verplicht ten minste één telefoonnummer in te vullen. Het invullen van een E-mailadres is aan te raden, maar optioneel.', position: 'right'},
              {element: '#step4', intro: 'Als laatste kunt u middels het aanvinken van de ‘Gegevens delen binnen afdeling’ box aangeven of de patiënt akkoord is gegaan met het delen van zijn/haar gegevens binnen uw afdeling. Als u meer wilt weten over deze functionaliteit, klik dan op de ‘Lees meer’ link onder de tekst.', position: 'right'},
              {element: '#step5', intro: 'Als u benodigde informatie heeft ingevuld en gecontroleerd, klik dan op de ‘Opslaan’ knop om verder te gaan!', position: 'right'}
            ],
            exitOnEsc: false,
            exitOnOverlayClick: false,
            skipLabel: 'Overslaan',
            nextLabel: 'Volgende >',
            prevLabel: '< Terug',
            doneLabel: 'Okey, begrepen'
          })
          this.intro.start().oncomplete(function () {
            document.getElementById('patientDetailsSave').click()
            store.commit('navigation/setDemoFlowStatus', {key: 'patientFollow', value: true})
          })
          window.scrollTo(0, 0)
        }, 1500)
      }
      this.showDisabledBSN = parseInt(this.patientGegevens.BSNnummer) > 0
      this.NoBSNNummer = !this.patientGegevens.HeeftBSNNummer
      if (this.patientGegevens.RedenGeenBSN) {
        this.patientGegevens.RedenGeenBSN = this.patientGegevens.RedenGeenBSN.toString()
      }
      this.differentShippingAddress = typeof this.patientGegevens.AfwijkendeAdres.Straatnaam === 'string'
      if (this.patientGegevens.WoonAdres.Straatnaam !== null) {
        this.disableAddress = true
      }
      if (this.patientGegevens.AfwijkendeAdres.Straatnaam !== null) {
        this.disableAlternateAddress = true
      }
      this.showOverledenDatum = this.patientGegevens.PatientIsOverleden
      Object.keys(this.disabledFields).forEach((key) => {
        if (this.patientGegevens[key] !== null) {
          this.disabledFields[key] = true
        }
      })
      if (this.patientGegevens.CustomerPhoneNumbers.length === 0) {
        store.commit('patient/setPatientGegevensPhoneNumber')
      }
      this.otherTelephoneNumber = this.patientGegevens.CustomerPhoneNumbers.length === 1 ? false : true;
    })
  },
  methods: {
    ...mapActions('patient', ['fetchAllPatientFormData', 'submitPatient']),
    onContactTypeChange (value, index) {
      this.patientGegevens.CustomerPhoneNumbers[index].IsMobileNumber = value
    },
    onTelephoneNumberSelect (selectedCountry, index) {
      this.patientGegevens.CustomerPhoneNumbers[index].PhoneNumberCountryCode = selectedCountry.iso2
    },
    getComputedPhoneNumber (number, index) {
      if (number[0] === "0") {
        let computedValue = number.substr(1)
        this.patientGegevens['CustomerPhoneNumbers'][index]['PhoneNumber'] = computedValue
        return computedValue
      }
      return number
    },
    savePhoneNumberInput (event, key, index) {
      this.patientGegevens[key][index]['PhoneNumber'] = event.target.value
    },
    closeModal () {
      store.commit('patient/setNewPatientIsSaved', false)
      this.newPatientIsSaved = false
      this.covSanityCheckNotMatchedModel = false
    },
    validateBeforeSubmit (e) {
      this.formSubmitted = true
      e.preventDefault()
      this.validateAllFields(e.currentTarget.elements)
    },
    goBack () {
      if (this.formPurpose !== 'new') {
        router.push('/patientdashboard')
      } else {
        router.push('/')
      }
    },
    submitFormRegardlessOfCovSanityCheck () {
      this.closeCovNotMatched()
      var patientForm = this.$refs.patientForm
      return this.submitForm(patientForm.elements, {
        covSanityCheckResolveMethod: 'UseProvidedDetails'
      });
    },
    submitForm (elements, options) {
      this.submitPatient({ elements, options }).then(response => {
        if (response.data.Success === true && response.data.Id) {
          pushActiveCustomerId(response.data.Id);
        }

        if (response.data.Success === true && response.data.successModel && !store.state.navigation.demo && !store.state.navigation.demoActivated) {
          store.commit('patient/setNewPatientIsSaved', true)
          this.patientDetailsSuccessPopUpDetails = response.data.successModel;
          if (this.currentPatientId === '0') {
            // Follow current (new) patient
            this.followPatient()
          }
        } else if (response.data.Success === true && response.data.covSanityCheckNotMatchedModel) {
          // covSanityCheckNotMatchedModel: contains details for the popup
          this.covSanityCheckNotMatchedModel = response.data.covSanityCheckNotMatchedModel;
        }
        return response;
      })
      .then(response => {
        if (store.state.navigation.demo) {
          this.intro.exit()
          router.push(response.data.RedirectUrl)
        }
      });
    },
    followPatient () {
      store.dispatch('patient/setPatientFollowStatus', {Follow: true})
      if (store.state.navigation.demo && store.state.navigation.demoActivated) {
        store.commit('navigation/setDemoFlowStatus', {key: 'patientFollow', value: false})
        store.commit('navigation/setDemoFlowStatus', {key: 'patientListing', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicense', value: true})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicenseTwoColumn', value: true})
        router.push('/mijnpatienten/' + store.state.patient.patientGegevens.Achternaam.charAt(0).toLowerCase())
      }
    },
    validateAllFields (elements) {
      if (this.patientGegevens.GeslachtId === 0) {
        this.showErrorMessage = true
      }
      if (this.patientGegevens.VerzekeraarId === '' || this.patientGegevens.VerzekeraarId === null) {
        this.showDeptErrorMessage = true
      } else {
        this.showDeptErrorMessage = false
      }
      this.$validateAllComponents().then(validated => {
        if (this.NoBSNNummer && !this.patientGegevens.RedenGeenBSN) {
          this.showNoBSNErrorMessage = true
          return
        }
        
        if (validated && !this.showDeptErrorMessage) {
          // submit patient
          this.submitForm(elements);
        } else {
          this.formSubmitted = false
        }
      })
    },
    onCountryChange (country, key) {
      this.selectedCountry = country
      if (country === 'BE') {
        // WoonAdresPostcode
        this[key] = {
          required: true,
          max: 4,
          numeric: true
        }
        return
      }
      if (country === 'DE') {
        // WoonAdresPostcode
        this[key] = {
          required: true,
          max: 5,
          numeric: true
        }
      }
    },
    moment (...args) {
      return moment(...args)
    },
    autoFillAddress (key) {
      store.dispatch('patient/fetchAddressLookup', {
        postcode: this.patientGegevens[key].Postcode,
        huisnummer: this.patientGegevens[key].Huisnummer,
        land: this.patientGegevens[key].Land
      }).then((response) => {
        if (response && response.data) {
          this.patientGegevens[key].Straatnaam = response.data.Street
          this.patientGegevens[key].Woonplaats = response.data.City
        }
        if (response.data.Street) {
          if (key === 'WoonAdres') {
            this.disableAddress = true
          } else {
            this.disableAlternateAddress = true
          }
        }
      }).catch(() => {
        if (key === 'WoonAdres') {
          this.disableAddress = false
        } else {
          this.disableAlternateAddress = false
        }
      })
    },
    careProgramAction (actionDetails) {
      store.commit('patient/setCustomerMarketingPermissionSubOption', actionDetails)
    },
    checkRadioAnswer (e) {
      this.patientGegevens[e.currentTarget.name] = e.currentTarget.value
      let radioButtonId = e.currentTarget.id
      if (radioButtonId === 'Q1N') {
        store.commit('patient/setCustomerMarketingPermission', null)
      } else {
        store.commit('patient/setCustomerMarketingPermission', 'default')
      }
    },
    closeCovNotMatched () {
      this.covSanityCheckNotMatchedModel = null;
    },
    closeCovNotMatchedAndScrollTop () {
      this.patientGegevens.VerzekeraarId = this.covSanityCheckNotMatchedModel.CovHealthcareInsuranceCompany ? 
        this.covSanityCheckNotMatchedModel.CovHealthcareInsuranceCompany.PayerId : null;
      this.patientGegevens.Polisnummer = this.covSanityCheckNotMatchedModel.CovPolicyNumber; 
      this.covSanityCheckNotMatchedModel = null;
      window.scrollTo(0, 0)
    },
    openGegevensLink (url) {
      window.open(url, '_blank')
    },
    showOtherTelephoneNumber (displayFlag, phoneNumberId) {
      this.otherTelephoneNumber = displayFlag
      if (!displayFlag && this.patientGegevens.CustomerPhoneNumbers.length > 1) {
        if (phoneNumberId !== 0) {
          axios.post('Customer/DeleteCustomerPhoneNumber', {PhoneNumberId: phoneNumberId}).then((response) => {
            if (response && response.data) {
              this.patientGegevens.CustomerPhoneNumbers.splice(-1)
            }
          });
        } else {
          this.patientGegevens.CustomerPhoneNumbers.splice(-1)
        }
      } else if (displayFlag && this.patientGegevens.CustomerPhoneNumbers.length === 1) {
        store.commit('patient/setPatientGegevensPhoneNumber')
      }
    },
    saveInput (event) {
      this.patientGegevens[event.target.id] = event.target.value
    },
    saveCustomerNumber () {
      store.commit('patient/setCustomerNumber', event.target.value)
    },
    saveAddressInput (event, key, childKey) {
      this.patientGegevens[key][childKey] = event.target.value
    },
    /**
     * @function select - Funtion that handles the select change
     */
    select (e, key) {
      this.patientGegevens[key] = key != 'Tussenvoegsel' && key != 'VerzekeraarId' ? parseInt(e.currentTarget.value, 10) : e.currentTarget.value
      if (this.patientGegevens[key] !== 0) {
        if (key === 'RedenGeenBSN') {
          this.showNoBSNErrorMessage = false
        }
        if (key === 'GeslachtId') {
          this.showErrorMessage = false
        }
      } else {
        if (key === 'RedenGeenBSN') {
          this.showNoBSNErrorMessage = true
        }
        if (key === 'GeslachtId') {
          this.showErrorMessage = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.patient-details {
  color: $gray-dark;
  .vue-country-select {
    border-color: $gray !important;
    /deep/
    .dropdown {
      height: 49px !important;
    }
    /deep/
    .country-code {
      margin-left: 5px;
    }
  }
  &__block {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: $white;
    &__content {
      padding: 24px;
    }
  }  
  table {
    margin-bottom: 24px !important;
    border-bottom: solid 2px #0000001A;
  }
  .form-group--disabled {
    /deep/
    label {
      padding: 0px !important;
    }
    /deep/
    select, select:disabled {
      background-color: #0000000D !important;
      border-color: $gray;
      min-height: 50px;
    }
  }
  .form-group, .form-group-simple, .form-group-simple--completed {
    /deep/
    input {
      color: $teal-darkest !important;
      height: 49px;
    }
    /deep/
    label {
      color: $teal-darkest;
      margin-bottom: 14px;
      font-weight: normal;
    }
    /deep/
    input:disabled {
      background-color: #0000000D !important;
    }
  }  
  /deep/
  .form-group {
    padding: 0px;
    label {
      position: initial;
      transform: none !important;
      line-height: normal;
      height: inherit;
      margin-bottom: 14px;
      font-size: $base-font-size;
      padding: 0px;
    }
    select {
      border-color: $gray;
    }
    .form-group__details {
      &:after {
        content: none;
      }
      &:before {
        content: none;
      }
    }
    &--disabled {
      background: none !important;
      background-color: #0000000D;
    }
  }
  .form-group-simple__error {
    .alert-circle-icon {
      display: inline-flex;
      width: 16px;
      height: 16px;
      fill: $pure-red;
      vertical-align: bottom;
    }
  }
}
/deep/
.step3_icon {
  .material-design-icon__svg {
    width: 35px !important;
    height: 35px !important;
  }
}
/deep/
.checkbox-group disabled .checkbox-group__label {
  color: $gray-light;
}
</style>
